module.exports = __webpack_public_path__ + "static/img/home-bg.80e585e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/grade/home-bg.png
// module id = exGt
// module chunks = 1